import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatStepperModule } from '@angular/material/stepper';
import { DxProgressBarModule } from 'devextreme-angular';
import { ContentPageWrapperComponent } from './pages/content-page-wrapper/content-page-wrapper.component';
import { DataService } from './services/data.service';
import { WizardImportComponent } from './wizard-import.component';
import { WizardImportService } from './wizard-import.service';

@NgModule({
  declarations: [WizardImportComponent, ContentPageWrapperComponent],
  exports: [WizardImportComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatStepperModule,
    MatFormFieldModule,
    MatMenuModule,
    MatIconModule,
    DxProgressBarModule,
    CdkStepperModule,
  ],
  providers: [WizardImportService, DataService, provideHttpClient(withInterceptorsFromDi())],
})
export class WizardImportModule {}
